import React, { Component } from 'react'
import moment from 'moment'
import _ from 'lodash'
import {  Button,Col } from 'react-bootstrap'
import {  reduxForm, propTypes,formValueSelector } from 'redux-form'
import { bindActionCreators } from 'redux'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { warning,forms,blue } from '../../../../utils/constants'
import  './style.css'
import  { generatetemplate,container } from './style'
import  { DoesMeetMinimunTeamCriteria,AllowTemplateDownload, DownLoadTemplate,DownloadAvailableDate }  from './Logic'

const FormName = forms.eventinfo

class EventTemplate extends Component {
	static propTypes = {
	...propTypes
	} 
	constructor(props) { 
		super(props)
		this.state = {
			generatingTemplate:false
		}
		this.handleDownloadTemplate = this.handleDownloadTemplate.bind(this)
	}
	componentDidMount(){
		window.scrollTo(0, 0)
	}
	handleDownloadTemplate(){
		const { eventId,eventname,startdate,enddate } = this.props
		this.setState({ generatingTemplate: true })
		DownLoadTemplate(eventId,eventname,startdate,enddate,this)
	}
	render() {
		const { generatingTemplate } = this.state
		const { previousPage,eventname,eventSeasonSettings,startdate,enddate,gettingTeamRosters } = this.props 
		const downloadAvailable = AllowTemplateDownload(eventSeasonSettings, startdate)
		const downloadButtonColor = downloadAvailable ? 'green':'gray'

		console.log('Inside Event template getting roster', gettingTeamRosters)

		return (
			<div>
				<div sm={12} style={container}>					
					<h5><span style={{ color:'green' }}>{_.startCase(_.toLower(eventname))} Tournament ( {moment(startdate).format('LL')} through {moment(enddate).format('LL')} )  </span></h5>
					<p>Thank you for completing your tournament setup.  </p>
					{
						gettingTeamRosters && 
						(	
							<div style={{ color:blue, fontSize:'16px', margin:'15px' }}>
								<p>	<i className='fa fa-spinner fa-spin' aria-hidden='true'  />&nbsp;&nbsp;Getting Participant Rosters. This could take a minute...</p>
							</div>
						)		
					}
					{
					!gettingTeamRosters &&	!DoesMeetMinimunTeamCriteria(this.props) && (
						<p style={{ color: warning , fontWeight:'bold' }}>      
							Current team count does not meet the event minimums for one or more genders. Please check your selections before proceeding to download the template.  
							No ranking points will be awarded to teams in divisions failing to meet minimum requirements. Scores will be used for average purposes only.
						</p>  
					)}
					{ 
						(!gettingTeamRosters && !generatingTemplate) && (<p sm={12}>
							To get tournament template, click this button  
							<Button  style={{ ...generatetemplate, color:{ downloadButtonColor }, borderColor:{ downloadButtonColor } }} onClick={this.handleDownloadTemplate} disabled={!downloadAvailable}>
								<i className="fa fa-file" aria-hidden="true"  />&nbsp;{' '} Generate template&nbsp;{' '}
							</Button>
							{!downloadAvailable && (<span style={{ color:warning }}>&nbsp;* Template download available on {DownloadAvailableDate(eventSeasonSettings, startdate)}</span>)}
						</p>) 
					}
					{
						(generatingTemplate) && 
						(
							<div style={{ color:blue, fontSize:'16px', margin:'15px' }}>
								<p>	<i className='fa fa-spinner fa-spin' aria-hidden='true'  />&nbsp;&nbsp;Generating template. Please submit tournament results no later than {moment(enddate).add(2,'days').format('LL')}...</p>
							</div>
						)
					}
					<p>      
						Please, submit results within 2 days after tournament completion.  Without it, team rankings calculations will not be accurate.
					</p>              
				</div> 
				<Col sm={12}> 
					<button type="button" className="btn btn-primary pull-left previous" onClick={previousPage} style={{ fontSize:'120%',fontWeight:'bold'  }}>
						<i className="fa fa-caret-left" aria-hidden="true"  />&nbsp;&nbsp;Previous
					</button> 
				</Col> 
			</div>             
		)
	}
}
EventTemplate.propTypes = {
	eventgendermen:PropTypes.bool,
	eventgenderwomen:PropTypes.bool,
	dispatch:PropTypes.func,
	previousPage:PropTypes.func,
	participantschools:PropTypes.array,
	minwomenteams:PropTypes.number,
	minmenteams:PropTypes.number,
	startdate:PropTypes.string,
	enddate:PropTypes.string,
	eventSeasonSettings:PropTypes.object,
	eventname:PropTypes.string,
	eventId:PropTypes.number,
	gettingTeamRosters:PropTypes.bool
}
function mapStateToProps(state,ownProps){ 
	const formName =  ownProps.form
	const selector = formValueSelector(formName)
	const participantschools = selector(state,'participantschools')
	const eventgendermen = selector(state,'eventgendermen')
	const eventgenderwomen = selector(state,'eventgenderwomen')
	const minmenteams = selector(state,'minmenteams')
	const minwomenteams = selector(state,'minwomenteams')
	const startdate = selector(state,'startdate')
	const enddate = selector(state,'enddate')
	const eventSeasonSettings = selector(state,'eventSeasonSettings')
	const eventname = selector(state,'eventname')
	const eventId   = selector(state,'eventId')
	const gettingTeamRosters = selector(state,'gettingTeamRosters')
	return {
		participantschools,
		eventgendermen,
		eventgenderwomen,
		minmenteams,
		minwomenteams,
		startdate,
		enddate,
		eventSeasonSettings,
		eventname,
		eventId,
		gettingTeamRosters
	}
} 
function mapDispatchToProps(dispatch){
	return bindActionCreators({},dispatch)
}
export default reduxForm({
	form:FormName,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: false
})(connect(mapStateToProps,mapDispatchToProps)(EventTemplate))



// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/EventTemplate/index.js